import React, { useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { listOrders } from '../actions/orderActions';

const OrderListScreen = ({ history }) => {
  const dispatch = useDispatch();

  const orderList = useSelector((state) => state.orderList);
  const { loading, error, orders } = orderList;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      dispatch(listOrders());
    } else {
      history.push('/login');
    }
  }, [dispatch, history, userInfo]);

  return (
    <>
      <h1 className='text-center'>Orders</h1>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Table
          striped
          bordered
          hover
          responsive
          className='table-sm text-center'
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>SUBTL</th>
              <th>TAX</th>
              <th>TOTAL</th>
              <th>EMAIL</th>
              <th>PAID</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order._id}>
                <td style={{ fontSize: '0.75rem' }}>
                  <small>{order._id} </small>
                  <br />
                  <small>BSID: {order.shortId}</small>
                </td>
                <td>
                  <small>${order.subTotal && order.subTotal.toFixed(2)}</small>
                </td>
                <td>
                  <small>${order.taxPrice && order.taxPrice.toFixed(2)}</small>
                </td>
                <td>
                  <small>${order.orderPrice}</small>
                </td>
                <td>
                  <small>{order.deliveryInfo.email}</small>
                </td>
                <td>
                  {order.isPaid ? (
                    <>
                      <i className='fas fa-check icon-sucess'></i>{' '}
                      <small style={{ color: 'green', fontSize: '0.5rem' }}>
                        {order.createdAt.substring(5, 10)}-
                        {order.createdAt.substring(2, 4)}
                      </small>
                    </>
                  ) : (
                    <>
                      <i className='fas fa-times' style={{ color: 'red' }}></i>
                      <small style={{ color: 'green', fontSize: '0.5rem' }}>
                        {' '}
                        (Not Paid)
                      </small>
                    </>
                  )}
                </td>
                {/* <td>
                  {order.isSent ? (
                    <i className='fas fa-check icon-success'></i>
                  ) : (
                    <i className='fas fa-times icon-danger'></i>
                  )}
                </td> */}
                <td>
                  <LinkContainer to={`/order/${order._id}`}>
                    <Button variant='light' className='btn-sm'>
                      Details
                    </Button>
                  </LinkContainer>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default OrderListScreen;
